import { React, useState } from "react";
import Heading from "../../common/Heading";
import ProjectCard from "./components/ProjectCard";
import { Container, ProjectBox, BigProjectBox } from "./project_elements";
import Modal from "react-awesome-modal";
import ProductModal from "./components/ProductModal";
import { projectSection, bigProject } from "../../data";

const Projects = ({ isBig }) => {
  const [menu, openModal] = useState(false);

  const [currentModalData, setcurrentModalData] = useState(projectSection[0]);

  return (
    <Container id="projects">
      <Heading
        heading={isBig ? "Big Projects 🚀" : "What i have done"}
        subheading={
          isBig
            ? "SOME STARTUPS AND COMPANIES THAT I AM NOW HELPING TO CREATE THEIR TECH"
            : "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH"
        }
      />
      {isBig ? (
        <BigProjectBox>
          {bigProject.map((project, i) => {
            return (
              <ProjectCard
                key={i}
                onTap={() => {
                  setcurrentModalData(project);

                  openModal(true);
                }}
                index={i}
                data={project}
              />
            );
          })}
        </BigProjectBox>
      ) : (
        <ProjectBox>
          {projectSection.map((project, i) => {
            return (
              <ProjectCard
                key={i}
                onTap={() => {
                  setcurrentModalData(project);

                  openModal(true);
                }}
                index={i}
                data={project}
              />
            );
          })}{" "}
        </ProjectBox>
      )}
      <Modal
        visible={menu}
        width="80%"
        height="80%"
        effect="fadeInUp"
        onClickAway={() => openModal(false)}
      >
        <ProductModal onTap={() => openModal(false)} data={currentModalData} />
      </Modal>
    </Container>
  );
};

export default Projects;
